import ProductsList from "../components/ProductsList";
import frisch from "../assets/circle_frisch.png";
import pralines from "../assets/circle_pralines.png";
import tablets from "../assets/circle_tablets.png";
import snacks from "../assets/circle_snacks.png";
import "./CatalogStyle.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { filterCategory } from "../redux/categorySlice";

function Catalog() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCategoryClick = (categorySelected) => {
    dispatch(filterCategory({ selected: categorySelected }));
    navigate("/catalog");
  };
  return (
    <div className="m-0 p-0" style={{ backgroundColor: "#F9F9F9" }}>
      <div className="container">
        <div
          className="row wow fadeInUp d-flex justify-content-between mt-4 mb-5"
          id="category"
        >
          <div
            className="col-lg-2 col-xl-2 "
            onClick={() => {
              handleCategoryClick("frischschoggi");
            }}
          >
            <p>FrischSchoggi</p>
            <img
              className="img"
              src={frisch}
              alt="frischschoggi"
              id="imgcatalog"
            />
          </div>
          <div
            className="col-lg-2 col-xl-2"
            onClick={() => {
              handleCategoryClick("pralines");
            }}
          >
            <p>Pralinés & Truffles</p>
            <img
              className="img"
              src={pralines}
              alt="pralines"
              id="imgcatalog"
            />
          </div>
          <div
            className="col-lg-2 col-xl-2"
            onClick={() => {
              handleCategoryClick("tablets");
            }}
          >
            <p>Tablets</p>
            <img className="img" src={tablets} alt="tablets" id="imgcatalog" />
          </div>
          <div
            className="col-lg-2 col-xl-2"
            onClick={() => {
              handleCategoryClick("snacking");
            }}
          >
            <p>Snacking</p>
            <img className="img" src={snacks} alt="snacks" id="imgcatalog" />
          </div>
        </div>
      </div>
      <ProductsList />
    </div>
  );
}

export default Catalog;
